import { render, staticRenderFns } from "./PgaOfferEvaluationDetailsInternalProjectDetails.vue?vue&type=template&id=ee654ace&"
import script from "./PgaOfferEvaluationDetailsInternalProjectDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationDetailsInternalProjectDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee654ace')) {
      api.createRecord('ee654ace', component.options)
    } else {
      api.reload('ee654ace', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationDetailsInternalProjectDetails.vue?vue&type=template&id=ee654ace&", function () {
      api.rerender('ee654ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/details/sub-components/PgaOfferEvaluationDetailsInternalProjectDetails.vue"
export default component.exports